import { Divider } from 'antd'
import { TRACKING_CODE_PLACEMENT, DELIVERY_STATUSES } from '@Orders/constants'
import {
    getDateDisplay,
    getShortDateDisplay,
} from '@Builder/QuotesHomePage/QuoteCheckoutSummary/logic'
import {
    getDeliveredDate,
    getTrackingCodeUrl,
} from '@Orders/OrderDetailsPage/Status/OrderedItems/components/SalesOrderLinesTable/logic'
import { salesOrder_salesOrder_shipments_items as ShipmentItemsType } from '@Orders/OrderDetailsPage/Queries/__generated__/salesOrder'
import { getDeliveryStateText } from '@Orders/OrderDetailsPage/logic'

import Box from '~/core/Box'
import Text from '~/core/Text'
import Link from '~/core/Link'

type ShipmentTabPropsType = {
    shipmentDetails?: ShipmentItemsType[] | null
}

export default function Shipment(props: ShipmentTabPropsType) {
    const { shipmentDetails } = props

    const trackingCodeLink = (shipmentItem: ShipmentItemsType) => {
        return (
            <Link
                name="tracking-code"
                placement={TRACKING_CODE_PLACEMENT}
                style={{
                    position: 'absolute',
                    right: '10px',
                }}
                href={getTrackingCodeUrl(
                    shipmentItem?.carrier,
                    shipmentItem?.trackingCode,
                )}
                target="_blank"
                data-test-target="tracking-code-link"
            >
                {shipmentItem?.trackingCode}
            </Link>
        )
    }

    return (
        <Box direction="col" marginBottom="16px">
            {shipmentDetails?.map((shipmentItem, index) => {
                const isDelivered =
                    shipmentItem.trackingData?.status ===
                    DELIVERY_STATUSES.DELIVERED

                return (
                    <Box direction="col" key={index}>
                        <Box marginTop="8px">
                            {shipmentItem.trackingData ? (
                                <Text
                                    color={
                                        isDelivered
                                            ? 'primary7'
                                            : 'blackAlpha45'
                                    }
                                >
                                    {getDeliveryStateText(
                                        shipmentItem.trackingData?.status,
                                    )}
                                </Text>
                            ) : (
                                <Text color="blackAlpha45">Shipped</Text>
                            )}
                            {shipmentItem.trackingCode &&
                                trackingCodeLink(shipmentItem)}
                        </Box>
                        <Box
                            color="blackAlpha65"
                            marginTop="8px"
                            direction="col"
                        >
                            {isDelivered ? (
                                <Box direction="col">
                                    <Box marginBottom="8px">
                                        {getDateDisplay(
                                            getDeliveredDate(shipmentItem),
                                        )}{' '}
                                    </Box>
                                    <Box>
                                        Signed by{' '}
                                        {shipmentItem?.trackingData?.signedBy}
                                    </Box>
                                </Box>
                            ) : (
                                <>
                                    Estimated delivery date:{' '}
                                    {getShortDateDisplay(
                                        shipmentItem?.trackingData
                                            ?.estDeliveryDate,
                                    )}
                                </>
                            )}
                            {index !== shipmentDetails?.length - 1 && (
                                <Divider />
                            )}
                        </Box>
                    </Box>
                )
            })}
        </Box>
    )
}
